export default {
  state: () => ({
    onlineIssuing: undefined,
    pos: undefined,
  }),
  mutations: {
    setOnlineIssuing(state, onlineIssuing) {
      state.onlineIssuing = onlineIssuing;
    },
    setPos(state, pos) {
      state.pos = pos;
    },
  },
  actions: {
    setOnlineIssuing(context, onlineIssuing) {
      context.commit('setOnlineIssuing', onlineIssuing);
    },
    setPos(context, pos) {
      context.commit('setPos', pos);
    },
  },
};
